import { ref } from 'vue';
import utdRest from '_acaSrc/utility/http/UtdRestHooks';

export default function useEmailCheck() {
    const isEmailAvailable = ref(null);
    const isCheckingEmail = ref(false);

    const checkEmailAvailability = async(email) => {
        if (!email) {
            isEmailAvailable.value = null;
            return null;
        }

        isCheckingEmail.value = true;
        try {
            const response = await utdRest('register/checkEmail', { email });
            isEmailAvailable.value = !response?.shouldSuggestMerge;
            return isEmailAvailable.value;
        }
        finally {
            isCheckingEmail.value = false;
        }
    };

    const resetEmailAvailability = () => {
        isEmailAvailable.value = null;
    };

    return {
        isEmailAvailable,
        isCheckingEmail,
        checkEmailAvailability,
        resetEmailAvailability
    };
}
